module.exports = __webpack_public_path__ + "img/7896b2b.svg";